// ✅ FULL TAILWIND VERSION (Fixed Upload + Update)

import React, { Component } from "react";
import { connect } from "react-redux";
import { dashboardActions, surveyActions } from "../../../_actions";
import * as XLSX from "xlsx";
import moment from "moment";
import LayoutWrap from "./Component/LayoutWrap";
import Table from "./Component/Table";
import { FaPlus } from "react-icons/fa";
import { LuUsers, LuUpload, LuSearch, LuChevronLeft, LuChevronRight, } from 'react-icons/lu';
import GiveFeedback from "./Modal/GiveFeedback";

class CoachPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fileUploadError: "",
      searchEmployee: "",
      showEmployeeModal: false,
      employeesize2: 10,
      currentSurveyPage: 1,
      employeeData: "",
      loadedDataSheet: [],
      showUploadPreview: false,
      pageNo: 1,
      size: 100,
      keyWord: "",
      formData: {
        "name": "",
        "emp_id": "",
        "email": "",
        "role": ""
      },
      updateFormData: {
        "id": "",
        "name": "",
        "emp_id": "",
        "email": "",
        "role": ""
      },
      updateEmployeeDetails: false,
      activeTab: 1,
      showDeleteConfirm: false,
      showFeedbackModal: false,
      CrrEmployeeId: "",
      feedbackSaveList: [],

      dimensionList: [
        "Champion Innovation",
        "Analytical Thinking",
        "Lead with Strategy",
        "Developing Others",
        "Change Leadership",
        "Customer Focus",
        "Communication"
      ]

    };
  }



  componentDidMount() {
    let data = { keyWord: "", pageNo: 1, size: 100 }
    this.props.dispatch(dashboardActions.getCoachEmployeeList(data));
    this.props.dispatch(dashboardActions.getInsightCompetencyList(data));

    this.props.dispatch(dashboardActions.getInsightAllFeedbacks({}));
  }

  // ✅ FIXED FILE UPLOAD
  handleChange = (e) => {
    const file = e.target.files?.[0];

    if (!file) {
      this.setState({ fileUploadError: "No file selected!" });
      return;
    }

    const fileName = file.name.toLowerCase();
    const isValid = fileName.endsWith(".csv") || fileName.endsWith(".xlsx");

    if (!isValid) {
      this.setState({ fileUploadError: "Please upload csv or xlsx file!" });
      return;
    }

    this.setState({
      file,
      fileUploadError: "",
      loadedDataSheet: [],
      showUploadPreview: true,
    });

    const reader = new FileReader();
    const rABS = !!reader.readAsBinaryString;

    if (rABS) reader.readAsBinaryString(file);
    else reader.readAsArrayBuffer(file);

    reader.onload = (event) => {
      const bstr = event.target.result;
      const wb = XLSX.read(bstr, {
        type: rABS ? "binary" : "array",
      });

      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];

      let data = XLSX.utils.sheet_to_json(ws);

      data = data.map((row) => {
        let newRow = { ...row };
        Object.keys(newRow).forEach((key) => {
          const val = newRow[key];
          if (moment(val, ["MM/DD/YYYY", "MM/DD/YY"], true).isValid()) {
            newRow[key] = moment(val).format("DD-MM-YYYY");
          }
        });
        return newRow;
      });

      this.setState({
        loadedDataSheet: data,
        showEmployeeModal: false,
      });
    };
  };

  // ✅ UPDATE FUNCTION
  handleUpdateEmployeeSubmit = () => {
    const { employeeData } = this.state;

    const payload = {
      id: employeeData.id,
      email: employeeData.email,
      mobile: employeeData.mobile,
      emp_id: employeeData.emp_id,
      role: employeeData.role,
      isTest: employeeData.isTest,
    };

    const refreshPayload = {
      keyWord: "",
      pageNo: 1,
      size: this.state.employeesize2,
    };

    this.props.dispatch(
      dashboardActions.updateInsightEmployee(payload, refreshPayload)
    );
  };

  handleEmployeeDetails = (emp) => {
    this.setState({ employeeData: emp });
  };

  saveUploadEmployee = () => {
    const { loadedDataSheet } = this.state;

    if (loadedDataSheet.length > 0) {

      let temp = { keyWord: "", pageNo: 1, size: 1000 }

      this.props.dispatch(
        dashboardActions.saveInsightEmployeeList(loadedDataSheet, temp)
      );
    }
  };


  downLoadSampleCSV = () => {
    let binary_univers = [
      {
        emp_id: "001",
        email: "sample@mail.com",
        name: "Employee001"
      },
    ];

    console.log("binary_univers: ", binary_univers);

    let binaryWS = XLSX.utils.json_to_sheet(binary_univers);

    // Create a new Workbook
    var wb = XLSX.utils.book_new();

    // Name your sheet
    XLSX.utils.book_append_sheet(wb, binaryWS, "Binary values");

    // export your excel
    XLSX.writeFile(wb, "sample employee.xlsx");
  };

  addEmployeeModal = (value) => {
    this.setState({ showEmployeeModal: value });
    this.setState({ fileUploadError: "" });
  };

  closeUploadPreview = () => {
    this.setState({ showUploadPreview: false });
  }


  handleSearch = (event) => {
    event.preventDefault();
    let { value } = event.target;
    this.setState({ keyWord: value, offset: 0 });
    let data = {
      "keyWord": value,
      "pageNo": this.state.pageNo,
      "size": this.state.size
    }
    this.props.dispatch(dashboardActions.getCoachEmployeeList(data));
  }


  handleSizeChange = (e) => {
    this.setState({
      size: Number(e.target.value),
      pageNo: 1
    });
  };

  goPrev = () => {
    this.setState((prev) => ({
      pageNo: Math.max(prev.pageNo - 1, 1)
    }));
  };

  goNext = () => {
    const { getCoachEmployeeListTotal } = this.props.dashboard;
    const totalPages = Math.ceil(getCoachEmployeeListTotal / this.state.size);
    this.setState((prev) => ({
      pageNo: Math.min(prev.pageNo + 1, totalPages)
    }));
  };

  handleInputChange = (e) => {
    let { formData } = this.state;
    formData[e.target.name] = e.target.value;
    this.setState({ formData })
  }

  handleUpdateChange = (e) => {
    let { updateFormData } = this.state;
    updateFormData[e.target.name] = e.target.value;
    this.setState({ updateFormData })
  }

  addNewEmployee = () => {
    let { formData } = this.state;
    let data = {
      "name": formData.name,
      "email": formData.email,
      "emp_id": formData.emp_id,
      "role": formData && formData.role ? formData.role : "USER"
    }
    let temp = { keyWord: "", pageNo: 1, size: 100 }
    this.props.dispatch(dashboardActions.createInsightEmployee(data, temp));
    this.setState({
      showEmployeeModal: false,
      formData: {
        "name": "",
        "email": "",
        "emp_id": "",
        "role": ""
      }
    })
  }

  updateNewEmployee = () => {
    let { updateFormData } = this.state;
    let data = {
      "id": updateFormData.id,
      "name": updateFormData.name,
      "email": updateFormData.email,
      "emp_id": updateFormData.emp_id
    }
    let temp = { keyWord: "", pageNo: 1, size: 100 }
    this.props.dispatch(dashboardActions.updateInsightEmployee(data, temp));
    this.setState({
      updateEmployeeDetails: false,
      updateFormData: {
        "id": "",
        "name": "",
        "email": "",
        "emp_id": ""
      }
    })
  }


  handleTabClick = (value) => { this.setState({ activeTab: value }) };

  onEdit = (value) => {
    let data = {
      "id": value.id,
      "name": value.name,
      "email": value.email,
      "emp_id": value.emp_id
    }
    this.setState({ updateEmployeeDetails: true, updateFormData: data })
  };

  closeUpdateEmployeeModal = () => {
    let data = {
      "id": "",
      "name": "",
      "email": "",
      "emp_id": ""
    }
    this.setState({ updateEmployeeDetails: false, updateFormData: data })
  }



  onDeleteConfirm = (data) => {
    this.setState({ showDeleteConfirm: true, updateFormData: { "id": data.id, "name": data.name } });
  }

  onCloseDeleteConfirm = () => {
    this.setState({ showDeleteConfirm: false });
  }

  finalDelete = () => {
    let { updateFormData } = this.state;
    let data = {
      "id": updateFormData.id
    }
    let temp = { keyWord: "", pageNo: 1, size: 100 }
    this.props.dispatch(dashboardActions.deleteInsightEmployee(data, temp));
    this.setState({ showDeleteConfirm: false, updateFormData: { "id": "", "name": "" } });
  }

  onFeedback = (item) => {
    console.log("item--->", item);
    const feedbackList = item.feedbackList.map(({ _id, ...rest }) => rest);
    console.log("feedbackList--x1->", feedbackList);

    let { dashboard } = this.props;
    let { getInsightCompetencyListData: x } = dashboard;
    let dimensionList = x && x.length > 0 ? x.map((ele) => (ele.name)) : [];

    const newfeedbackSaveList = dimensionList.map((x) => ({
      dimension: x,
      rating: 0,
      feedback: ""
    }));
    console.log("newfeedbackSaveList--1--->", newfeedbackSaveList)


    this.setState({ CrrEmployeeId: item.id, feedbackSaveList: feedbackList && feedbackList.length > 0 ? feedbackList : newfeedbackSaveList }, () => {
      this.setState({ showFeedbackModal: true });
    })
  }

  closeFeedback = () => {

    let { dashboard } = this.props;
    let { getInsightCompetencyListData: x } = dashboard;
    let dimensionList = x && x.length > 0 ? x.map((ele) => (ele.name)) : [];

    const newfeedbackSaveList = dimensionList.map((x) => ({
      dimension: x,
      rating: 0,
      feedback: ""
    }));
    console.log("newfeedbackSaveList--2--->", newfeedbackSaveList)

    this.setState({ showFeedbackModal: false, feedbackSaveList: newfeedbackSaveList })
  }

  submitFeedback = (data) => {
    let { CrrEmployeeId } = this.state;
    let temp = {
      "employeeId": CrrEmployeeId,
      "feedbackList": data
    }
    this.props.dispatch(dashboardActions.submitCoachFeedback(temp));
    this.closeFeedback()
  }

  handleFeedbackUpdate = (dimension, fieldName, value) => {
    this.setState((prevState) => ({
      feedbackSaveList: prevState.feedbackSaveList.map((item) =>
        item.dimension === dimension
          ? { ...item, [fieldName]: value }
          : item
      )
    }));
  };

  downLoadFeedbacks = () => {
    let { dashboard } = this.props;
    let { getInsightAllFeedbacksData } = dashboard;

    function formatFeedbackList(data) {
      if (data && data.length > 0) {
        return data.map(emp => {
          const obj = {
            name: emp.employeeId?.name || ""
          };

          (emp.feedbackList || []).forEach(item => {
            obj[item.dimension] = item.feedback || "";
          });

          return obj;
        });
      } else {
        return []
      }
    }


    let binary_univers = formatFeedbackList(getInsightAllFeedbacksData);

    let binaryWS = XLSX.utils.json_to_sheet(binary_univers);
    var wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, binaryWS, "Binary values");
    XLSX.writeFile(wb, "All Feedbacks.xlsx");
  };

  render() {
    const { dashboard } = this.props;
    const { getInsightAllFeedbacksData = [], getCoachEmployeeListData = [], getCoachEmployeeListTotal, getCoachEmployeefeedbackList } = dashboard;
    let { feedbackSaveList, showFeedbackModal, updateFormData, updateEmployeeDetails, activeTab, formData, loadedDataSheet, showEmployeeModal, showUploadPreview, pageNo, size } = this.state;


    function getFeedbackDetaisl(list = [], employeeId) {
      const index = list.findIndex(item => item?.employeeId === employeeId);
      return index !== -1 ? list[index].feedbackList : [];
    }

    function getStatus(list = []) {
      return list.every(item => item?.feedback?.trim()) ? "Completed" : "Pending";
    }

    const list = getCoachEmployeeListData && getCoachEmployeeListData.length > 0 ?
      getCoachEmployeeListData.map((ele, i) => ({
        sno: i + 1,
        id: ele.id,
        emp_id: ele.emp_id,
        name: ele.name,
        email: ele.email,
        feedbackList: getFeedbackDetaisl(getCoachEmployeefeedbackList, ele.id),
        statue: getStatus(getFeedbackDetaisl(getCoachEmployeefeedbackList, ele.id)),
        createdAt: moment(ele.createdAt)
          .utcOffset("+05:30")
          .format("DD MMM, YYYY")
      })) : []
    console.log("listx--->", list);

    const columns = [
      { label: "S.No", key: "sno" },
      { label: "Name", key: "name" },
      { label: "Email", key: "email" },
      { label: "Status", key: "statue" },
      { label: "Created At", key: "createdAt" },
    ];

    const start = getCoachEmployeeListTotal === 0 ? 0 : (pageNo - 1) * size + 1;
    const end = Math.min(pageNo * size, getCoachEmployeeListTotal);
    const totalPages = Math.ceil(getCoachEmployeeListTotal / size);



    console.log("getInsightAllFeedbacksData----x----x---->", getInsightAllFeedbacksData)


    return (
      <LayoutWrap>
        <div className="h-screen overflow-y-auto md:p-8 p-4 ">
          <div className="bg-white space-y-4 pb-24">

            {/* Header */}
            <div className="flex justify-between items-center">
              <h1 className="text-xl sm:text-2xl font-medium textblack">
                My Team
              </h1>
              <button onClick={() => this.downLoadFeedbacks()} className="flex items-center gap-2 bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2 font-medium rounded-md shadow-sm whitespace-nowrap">
                <span>Download Feedbacks</span>
              </button>
            </div>


            {/* CARD */}
            <div className="border border-gray-300 rounded-lg overflow-hidden   bg-white ">
              {/* TOOLBAR */}
              <div className="p-3 md:p-4 border-b border-gray-100 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                {/* LEFT */}
                <div className="flex items-center gap-3">
                  <div className="flex items-center gap-2 text-sm textblack">
                    Show
                    <select
                      className="border border-gray-300 bg-white outline-none rounded-md px-2 py-1 font-semibold"
                      value={this.state.size} onChange={this.handleSizeChange}
                    >
                      <option value={10}>10</option>
                      <option value={20}>20</option>
                      <option value={50}>50</option>
                      <option value={100}>100</option>
                    </select>
                    Entries
                  </div>
                </div>

                {/* RIGHT */}
                <div className="flex flex-col sm:flex-row gap-3 w-full md:w-auto">

                  {/* SEARCH */}
                  <div className="relative w-full sm:w-64">
                    <LuSearch
                      className="absolute left-3 top-1/2 -translate-y-1/2 textblack"
                      size={16}
                    />
                    <input
                      type="text"
                      value={this.state.keyWord}
                      onChange={this.handleSearch}
                      placeholder="Search..."
                      className="w-full pl-9 pr-3 py-2 border border-gray-300 textblack placeholder:text-gray-800 rounded-md text-sm outline-none"

                    />
                  </div>

                  {/* PAGINATION */}
                  <div className="flex items-center gap-3 text-sm textblack">
                    <span>{start}-{end}  of {getCoachEmployeeListTotal}</span>
                    <div className="flex gap-1">
                      <button onClick={this.goPrev} disabled={this.state.pageNo === 1} className="p-1 border rounded">
                        <LuChevronLeft size={18} />
                      </button>
                      <button onClick={this.goNext} disabled={this.state.pageNo === totalPages} className="p-1 border rounded bg-purple-50 text-indigo-600">
                        <LuChevronRight size={18} />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <Table
                list={list}
                columns={columns}
                onFeedback={this.onFeedback}
              />
            </div>

          </div>


          {showFeedbackModal ?
            <GiveFeedback
              closeFeedback={this.closeFeedback}
              feedbackSaveList={feedbackSaveList}
              handleFeedbackUpdate={this.handleFeedbackUpdate}
              submitFeedback={this.submitFeedback}
            />
            : null}


        </div>
      </LayoutWrap>
    );
  }
}

const mapStateToProps = (state) => {
  const { dashboard } = state;
  return { dashboard };
};

export default connect(mapStateToProps)(CoachPanel);